import React, { useState, useEffect } from "react";
import { API_URL } from "../../../../constants";
import { Table } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaSpinner } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useLocation } from "react-router-dom";
import { AlertCircle } from "lucide-react";

const TeamPerformanceEvaluation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const cycleidURL = queryParams.get("cycleid");
  const empIDURL = queryParams.get("empid");

  useEffect(() => {
    fetchOpts();
    dispatch(updateNavbarHeading("Team Performance Evaluation"))
  }, [])


  const today = moment();
  const formattedDate = today.format("DD-MMM-YYYY");
  const [cycle_Id, setcycle_Id] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [appraisalMasterID, setAppraisalMasterID] = useState(null);
  const [pr_id, setID] = useState(null);
  const [formData, setFormData] = useState({});
  const [formTemplate, setFormTemplate] = useState([]);
  const [employeData, setEmployeData] = useState(null);
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  const [appraisalCycleList, setAppraisalCycleList] = useState([]);
  const [empList, setEmpList] = useState([]);
  console.log("empList", empList);

  const [defaultEmployee, setDefaultEmployee] = useState(null);
  console.log("defaultEmployee", defaultEmployee);

  const [appraisalCycleError, setAppraisalCycleError] = useState("");
  const [formVisible, setFormVisible] = useState(false);
  const [formCount, setFormCount] = useState(1);
  const [reviewerFormData, setReviewerFormData] = useState({});
  const [userSessionData, setUserSessionData] = useState(JSON.parse(localStorage.getItem("user")))
  const [selectedCycle, setSelectedCycle] = useState(null);
  const [appProcessType, setAppProcessType] = useState("");
  const [appProcessID, setAppProcessID] = useState("");
  const [pageLaoding, setPageLaoding] = useState(false);
  const [loading, setLoading] = useState(false)
  const [loadingDraft, setLoadingDraft] = useState(false)
  const [errorMessages, setErrorMessages] = useState({});


  useEffect(() => {

    if (empIDURL && cycleidURL) {
      setcycle_Id(cycleidURL)
      setEmployeeId(empIDURL)
      setDefaultEmployee(empIDURL)
      setTimeout(() => {
        fetchFormTemplate(empIDURL, cycleidURL)
      }, 3000)
    }
  }, [empIDURL, cycleidURL])





  const [fetchTemplate, setFetchTemplate] = useState(false)
  const fetchOpts = async () => {
    try {
      const queryParams = new URLSearchParams({ cycleId: null ?? '' }).toString();
      const response = await GetServiceCaller(`${API_URL}team-performance-evaluation/create?${queryParams}`);

      if (response?.status === 200) {
        const cycleList = response?.data?.data?.cycleList?.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setAppraisalCycleList(cycleList);
        setcycle_Id(cycleidURL ?? cycleList?.[0]?.value);
        setSelectedCycle(cycleidURL ?? cycleList?.[0]);

        const empListData = Object.values(response?.data?.data?.team_list)?.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setEmpList(empListData);

        // decide employee
        let empToSet = empIDURL ?? empListData?.[0]?.value ?? userSessionData?.DefaultContactID;

        setDefaultEmployee(empToSet);
        setEmployeeId(empToSet);



      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    if (fetchTemplate) {
      fetchFormTemplate()
    }
  }, [fetchTemplate])

  //  const fetchOptsCycleID = async (cycleId) => {
  //   try {
  //     const queryParams = new URLSearchParams({ cycleId: cycleId ?? '' }).toString();
  //     const response = await GetServiceCaller(`${API_URL}team-performance-evaluation/create?${queryParams}`);

  //     if (response?.status === 200) {
  //       const empListData = Object.values(response?.data?.data?.team_list)?.map((item) => ({
  //         value: item.value,
  //         label: item.text,
  //       }));

  //       setEmpList(empListData);

  //       let empToSet = empIDURL ?? userSessionData?.DefaultContactID ?? empListData?.[0]?.value;

  //       setDefaultEmployee(empToSet);
  //       setEmployeeId(empToSet);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };


  // useEffect(() => {
  //   if (cycle_Id) {
  //     fetchOptsCycleID(cycle_Id);
  //   }
  // }, [cycle_Id]);

  const handleCycleChange = (selectedOption) => {
    setcycle_Id(selectedOption ? selectedOption.value : null);
    setSelectedCycle(selectedOption)
    // user select option error message will disappear
    if (selectedOption?.value) {
      setAppraisalCycleError('');
    }
  };

  const handleEmployeeChange = (selectedOption) => {
    setDefaultEmployee(selectedOption?.value);
    setEmployeeId(selectedOption?.value);
  };


  // Helper function to map answer back to option key
  const getOptionKeyFromAnswer = (question, answer) => {
    if (answer === question.Option1) return "Option1";
    if (answer === question.Option2) return "Option2";
    if (answer === question.Option3) return "Option3";
    if (answer === question.Option4) return "Option4";
    return "";
  };


  const [templateAPIStatus, setTemplateAPIStatus] = useState('')
console.log("templateAPIStatus",templateAPIStatus);

  const [templateMessage, setTemplateMessage] = useState('')
  const fetchFormTemplate = async (empIDURL, cycleidURL) => {
    if (!cycle_Id && !cycleidURL) {
      setAppraisalCycleError("Appraisal Cycle is required");
      return;
    } else {
      setAppraisalCycleError("");
    }

    // Reset states
    setFormData({});
    setReviewerFormData({});
    setEmployeData(null);
    setFormTemplate([]);
    setFormVisible(false);

    const dataForm = {
      cycle_id: cycle_Id ?? cycleidURL,
      employee_id: employeeId ?? empIDURL,
    };

    setPageLaoding(true);

    try {
      const response = await PostFormServiceCaller(
        `${API_URL}fetch-teams-performance-evaluation-info`,
        dataForm
      );
      setTemplateAPIStatus(response?.status)

      if (response?.status == 201) {
        setTemplateMessage(response?.data?.message)
      }
      if (response?.data) {
        setPageLaoding(false);
        const performanceEvaluationHeader = response?.data?.data?.performanceEvaluationLines;
        const appraisalTemplateID =
          response?.data?.data?.performanceEvaluationHeader?.[0]?.AppraisalTemplateMasterID ??
          response?.data?.data?.performanceEvaluationHeader?.AppraisalTemplateMasterID ??
          null;
        setAppraisalMasterID(appraisalTemplateID);

        const ID = response?.data?.data?.performanceEvaluationHeader?.ID;
        setID(ID);

        const appraisalProcessCycleType = response?.data?.data?.performanceEvaluationHeader?.AppraisalCycleProcessType;
        setAppProcessType(appraisalProcessCycleType);

        const appraisalProcessCycleID = response?.data?.data?.performanceEvaluationHeader?.AppraisalCycleType;
        setAppProcessID(appraisalProcessCycleID);

        const cycleDetails = response?.data?.data?.performanceEvaluationLines;
        setFormTemplate(cycleDetails || []);

        const initialFormData = {};
        const initialReviewerFormData = {};

        cycleDetails.forEach((question) => {
          const questionId = question.QuestionMasterID;

          // Process EMPLOYEE data based on question type
          if (question.QuestionType_202 === 1342) {
            // Text input for employee
            initialFormData[questionId] = {
              answer: question.EmployeeAnswer || "",
              EmployeeRating: question.EmployeeRating || null,
            };
          } else if (question.QuestionType_202 === 1343) {
            // Radio buttons for employee
            const selectedOption = getOptionKeyFromAnswer(question, question.EmployeeAnswer);
            initialFormData[questionId] = {
              EmployeeRating: question.EmployeeRating || null,
              selectedOption: selectedOption,
              selectedOptionLabel: question.EmployeeAnswer ? [question.EmployeeAnswer] : [],
            };
          } else if (question.QuestionType_202 === 1347) {
            // Checkboxes for employee
            const selectedLabels = question.EmployeeAnswer
              ? question.EmployeeAnswer.split(",").map((label) => label.trim())
              : [];

            const selectedOptions = [];
            if (selectedLabels.includes(question.Option1)) selectedOptions.push("Option1");
            if (selectedLabels.includes(question.Option2)) selectedOptions.push("Option2");
            if (selectedLabels.includes(question.Option3)) selectedOptions.push("Option3");
            if (selectedLabels.includes(question.Option4)) selectedOptions.push("Option4");

            initialFormData[questionId] = {
              selectedOptions: selectedOptions,
              selectedOptionLabel: selectedLabels,
              EmployeeRating: parseFloat(question.EmployeeRating) || 0,
            };
          }          

          // Process REVIEWER data based on question type - SEPARATE from employee data
          if (question.QuestionType_202 === 1342) {
            // Text input for reviewer
            initialReviewerFormData[questionId] = {
              reviewerans: question.ReviewerAnswer || "",
              ReviewerRating: question.ReviewerRating || null,
            };
          } else if (question.QuestionType_202 === 1343) {
            // Radio buttons for reviewer
            const reviewerSelectedOption = getOptionKeyFromAnswer(question, question.ReviewerAnswer);
            initialReviewerFormData[questionId] = {
              ReviewerRating: question.ReviewerRating || null,
              selectedOptions: reviewerSelectedOption,
              selectedOptionLabel: reviewerSelectedOption,
            };
          } else if (question.QuestionType_202 === 1347) {
            // Checkboxes for reviewer
            const reviewerSelectedLabels = question.ReviewerAnswer
              ? question.ReviewerAnswer.split(",").map((label) => label.trim())
              : [];

            const reviewerSelectedOptions = [];
            if (reviewerSelectedLabels.includes(question.Option1)) reviewerSelectedOptions.push("Option1");
            if (reviewerSelectedLabels.includes(question.Option2)) reviewerSelectedOptions.push("Option2");
            if (reviewerSelectedLabels.includes(question.Option3)) reviewerSelectedOptions.push("Option3");
            if (reviewerSelectedLabels.includes(question.Option4)) reviewerSelectedOptions.push("Option4");

            initialReviewerFormData[questionId] = {
              selectedOptions: reviewerSelectedOptions,
              selectedOptionLabel: reviewerSelectedLabels,
              ReviewerRating: question?.ReviewerRating || 0,
            };
          } else {
            // Default case for reviewer
            initialReviewerFormData[questionId] = {
              reviewerans: question.ReviewerAnswer || "",
              ReviewerRating: question.ReviewerRating || null,
            };
          }
        });

        setReviewerFormData(initialReviewerFormData);
        setFormData(initialFormData);
        setFormVisible(true);

        const empDetails = response?.data?.data?.employeeDetails?.[0] || response?.data?.data?.employeeDetails;
        setEmployeData(empDetails);

        const user = JSON.parse(localStorage.getItem("user"));
        const defaultContactID = user?.DefaultContactID;
        if (defaultContactID) {
          const currentContactID = empDetails?.ContactID;
          if (currentContactID) {
            setFormCount(currentContactID === defaultContactID ? 1 : 2);
          }
        }
      } else {
        console.error("No data found in response");
        const errorMessage = response?.data?.data?.message || "An unexpected error occurred while making the request";
        // toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error fetching Form Template:", error);
      // toast.error("Failed to fetch form template. Please try again.");
    } finally {
      setPageLaoding(false);
    }
  };

  const handleTextChange = (e, questionId, question) => {
    const newText = e.target.value;
    setFormData({
      ...formData,
      [questionId]: { ...formData[questionId], answer: newText },
    });

    const minChars = question?.QuestionMinCharacter || 10;
    const maxChars = question?.QuestionMaxCharacter || 500;
    const textLength = newText.trim().length;

    if (textLength === 0) {
    // if (newText.length < 10) {
      setError({
        ...error,
        [questionId]: `Answer is required.`,
      });
    } else if (textLength < minChars) {
      setError({
        ...error,
        [questionId]: `Answer must be at least ${minChars} characters long.`,
      });
      // newErrors[questionId] = `Answer must be at least ${minChars} characters long.`;
    } else if (textLength > maxChars) {
      setError({
        ...error,
        [questionId]: `Answer cannot exceed ${maxChars} characters.`,
      });
      // newErrors[questionId] = `Answer cannot exceed ${maxChars} characters.`;
    } else {
      setError({
        ...error,
        [questionId]: "",
      });
    }
  };
  const handleRadioChange = (e, questionId, optionLabel, item) => {
    console.log("e, questionId, optionLabel, item", e, questionId, optionLabel, item);

    const selectedValue = e.target.value;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: {
        ...prevFormData[questionId],
        EmployeeRating: selectedValue,
        selectedOptionLabel: optionLabel,
      },
    }));

    // Clear error for this question
    setError((prevError) => ({
      ...prevError,
      [questionId]: "",
    }));
  };

  const handleSubmit = async (e, isDraft = false) => {
    e.preventDefault();


    let hasErrors = false;
    const newErrors = {};

    formTemplate.forEach((question) => {
      const response = formData[question.QuestionMasterID];

      if (question.QuestionType_202 === 1342) {

        if (!response?.answer?.trim()) {
          newErrors[question.QuestionMasterID] = "This field is required";
          hasErrors = true;
        } else if (response.answer.length < 10) {
          newErrors[question.QuestionMasterID] = `Please lengthen text to 10 or more characters (you are currently using ${response.answer.length} characters).`;
          hasErrors = true;
        }

        if (!response?.EmployeeRating || parseFloat(response.EmployeeRating) === 0 || parseFloat(response.EmployeeRating) === null) {
          newErrors[question.QuestionMasterID + "_rating"] = "Rating is required and cannot be 0";
          hasErrors = true;
        }
      } else if (question.QuestionType_202 === 1343) {

        if (!response?.EmployeeRating) {
          newErrors[question.QuestionMasterID] = "Please select an option";
          hasErrors = true;
        }
      } else if (question.QuestionType_202 === 1347) {
        if (!response?.selectedOptionLabel || response.selectedOptionLabel.length === 0) {
          newErrors[question.QuestionMasterID] = "Please select at least one option";
          hasErrors = true;
        }
      }
    });

    setError(newErrors);

    if (hasErrors) {
      toast.error("Please fill all required fields correctly!");
      return;
    }

    const formattedData = formTemplate.map((question) => {
      const response = formData[question.QuestionMasterID];
      let employeeAnswer = "";
      let employeeRating = "";

      if (question.QuestionType_202 === 1342) {
        employeeAnswer = response?.answer || "";
      } else if (
        question.QuestionType_202 === 1343
      ) {
        // Use the selected option to determine the answer
        if (response?.selectedOptions === "Option1") {
          employeeAnswer = question.Option1;
          employeeRating = question.OptionWeightage1;
        } else if (response?.selectedOptions === "Option2") {
          employeeAnswer = question.Option2;
          employeeRating = question.OptionWeightage2;
        } else if (response?.selectedOptions === "Option3") {
          employeeAnswer = question.Option3;
          employeeRating = question.OptionWeightage3;
        } else if (response?.selectedOptions === "Option4") {
          employeeAnswer = question.Option4;
          employeeRating = question.OptionWeightage4;
        }
      } else if (question.QuestionType_202 === 1347) {
        employeeAnswer = response?.selectedOptionLabel?.join(", ") || "";
        employeeRating = response?.EmployeeRating || 0;
      }

      return {
        QuestionMasterID: question.QuestionMasterID,
        QuestionType_202: question.QuestionType_202,
        EmployeeAnswer: employeeAnswer,
        EmployeeRating: response?.EmployeeRating || null,
      };
    });
    const payload = {
      AppraisalCycleID: cycle_Id || null,
      EmployeeID: defaultEmployee || null,
      AppraisalTemplateMasterID: appraisalMasterID,
      IsReviewDraft: isDraft ? "1" : "0",
      Lines: formattedData,
    };
    setLoading(true)

    try {
      const response = await PostServiceCaller(
        `${API_URL}add-employee-performance-evaluation`,
        payload,
        "post"
      );

      if (response.status === 200) {
        if (isDraft) {
          toast.success("Saved Successfully!");
        } else {
          toast.success("Form submitted successfully!");
        }
        // window.location.reload();
        setTimeout(() => {
          setFormCount(0)
          setEmployeData(null)
          setReviewerFormData([])
        }, 2000)
      }
    } catch (error) {
      console.error("There was an error submitting the form data!", error);
      toast.error("Error submitting form data.");
    } finally {
      setLoading(false)

    }
  };

  const handleReviewerRadioChange = (e, questionId, label, item) => {

    const selectedValue = e.target.value;

    setReviewerFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: {
        ...prevFormData[questionId],
        ReviewerAnswer: item.option,
        ReviewerRating: selectedValue || null,
        selectedOptionLabel: label,
        selectedOptions: label
      },
    }));

    setErrorMessages((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[questionId]; // Clear error on valid selection
      return newErrors;
    });
  };


  const handleReviewerCheckboxChange = (e, questionId, optionKey, optionLabel) => {
    const { checked, value } = e.target;

    setReviewerFormData(prevFormData => {
      const currentQuestionData = prevFormData[questionId] || {};

      // Create new arrays to avoid mutation issues
      const selectedOptions = Array.isArray(currentQuestionData.selectedOptions)
        ? [...currentQuestionData.selectedOptions]
        : [];

      const selectedOptionLabel = Array.isArray(currentQuestionData.selectedOptionLabel)
        ? [...currentQuestionData.selectedOptionLabel]
        : [];

      // Get current total weightage
      const currentTotalWeightage = currentQuestionData.ReviewerRating
        ? parseFloat(currentQuestionData.ReviewerRating) || 0
        : 0;      

      const weightage = parseFloat(value);

      if (isNaN(weightage)) {
        console.warn("Invalid weightage:", value);
        return prevFormData;
      }

      if (!optionKey) {
        console.warn("Invalid optionKey", optionKey);
        return prevFormData;
      }

      let newTotalWeightage = currentTotalWeightage;

      if (checked) {
        // Add the option if not already present
        if (!selectedOptions.includes(optionKey)) {
          selectedOptions.push(optionKey);
          if (optionLabel !== undefined && optionLabel !== null) {
            selectedOptionLabel.push(optionLabel);
          }
          newTotalWeightage += weightage;
        }
      } else {
        // Find the index and remove from all arrays
        const optionIndex = selectedOptions.indexOf(optionKey);
        if (optionIndex > -1) {
          selectedOptions.splice(optionIndex, 1);
          // Remove from label array at the same index
          if (optionIndex < selectedOptionLabel.length) {
            selectedOptionLabel.splice(optionIndex, 1);
          }
          newTotalWeightage -= weightage;
        }
      }

      return {
        ...prevFormData,
        [questionId]: {
          ...currentQuestionData,
          selectedOptions,
          selectedOptionLabel,
          ReviewerRating: newTotalWeightage.toFixed(2) // Use toFixed for consistent formatting
        }
      };
    });

    setErrorMessages(prevErrors => {
      const newErrors = { ...prevErrors };
      if (checked) {
        delete newErrors[questionId];
      }
      return newErrors;
    });
  };

  const handleReviewerTextChange = (e, questionId, question) => {
    const newText = e.target.value;
    setReviewerFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: { ...prevFormData[questionId], reviewerans: newText },
    }));

    setErrorMessages((prevErrors) => {
      const newErrors = { ...prevErrors };
      const minChars = question?.QuestionMinCharacter || 10;
      const maxChars = question?.QuestionMaxCharacter || 500;
      const textLength = newText.trim().length;

      if (textLength === 0) {
        newErrors[questionId] = "Answer is required.";
      } else if (textLength < minChars) {
        newErrors[questionId] = `Answer must be at least ${minChars} characters long.`;
      } else if (textLength > maxChars) {
        newErrors[questionId] = `Answer cannot exceed ${maxChars} characters.`;
      } else {
        delete newErrors[questionId]; // Clear error if valid
      }
      return newErrors;
    });
  };

  const handleTextRatingChange = (e, questionId, question) => {
    const newRating = e.target.value;
    const numericValue = parseFloat(newRating);
    const maxLimit = question?.Weightage || 10;
    const isValidRating = !isNaN(numericValue) && numericValue >= 0 && numericValue <= maxLimit;

    setReviewerFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: {
        ...prevFormData[questionId],
        ReviewerRating: newRating,
      },
    }));

    setErrorMessages((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (newRating.trim() === "") {
        newErrors[`${questionId}_rating`] = "Rating is required.";
      } else if (!isValidRating) {
        newErrors[`${questionId}_rating`] = `Please enter a valid number between 0 and ${maxLimit}.`;
      } else {
        delete newErrors[`${questionId}_rating`];
      }
      return newErrors;
    });
  };

  const handleReviewerSubmit = async (e, isDraft = false) => {
    e.preventDefault();
    let errors = {};

    if (!isDraft) {
      formTemplate.forEach((question) => {
        const response = reviewerFormData[question.QuestionMasterID] || {};
        const questionId = question.QuestionMasterID;

        if (question.QuestionType_202 === 1342) {
          if (!response?.reviewerans?.trim()) {
            errors[questionId] = "Answer is required.";
          } else {
            const minChars = question?.QuestionMinCharacter || 10;
            const maxChars = question?.QuestionMaxCharacter;
            const answerLength = response.reviewerans.trim().length;
            
            if (answerLength < minChars) {
              errors[questionId] = `Minimum ${minChars} characters required.`;
            } else if (maxChars && answerLength > maxChars) {
              errors[questionId] = `Maximum ${maxChars} characters allowed.`;
          }
          }

          // Rating validation
          if (!response?.ReviewerRating) {
            errors[`${questionId}_rating`] = "Rating is required.";
          } else {
            const rating = parseFloat(response.ReviewerRating);
            const maxWeight = parseFloat(question?.Weightage) || 10.00;
            
            if (isNaN(rating) || rating < 0 || rating > maxWeight) {
              errors[`${questionId}_rating`] = `Enter a value between 0 and ${maxWeight.toFixed(2)}.`;
            }
          }
        } else if (question.QuestionType_202 === 1343) {
          // Radio button validation
          if (!response?.ReviewerRating) {
            errors[questionId] = "Please select an option.";
          }
        } else if (question.QuestionType_202 === 1347) {
          // Checkbox validation
            if (!response?.selectedOptionLabel?.length) {
              errors[questionId] = "Please select at least one option.";
            } else {
              // Validate that ReviewerRating is properly calculated
              const rating = parseFloat(response.ReviewerRating) || 0;
              const maxPossible = parseFloat(question.OptionWeightage1 || 0) +
                                  parseFloat(question.OptionWeightage2 || 0) +
                                  parseFloat(question.OptionWeightage3 || 0) +
                                  parseFloat(question.OptionWeightage4 || 0);
              
              // Check if rating is valid (should be sum of selected weightages)
              if (rating > maxPossible) {
                errors[`${questionId}_rating`] = `Rating exceeds maximum possible value of ${maxPossible.toFixed(2)}.`;
              }
          }
        }
      });

      if (Object.keys(errors).length > 0) {
        setErrorMessages(errors);

        // Scroll to first error
        const firstErrorKey = Object.keys(errors)[0];
        const errorElement = document.querySelector(`[data-question-id="${firstErrorKey}"]`);
        // if (errorElement) {
        //   errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // }

        toast.error("Please fix the validation errors before submitting.");
        return;
      }
    }

    setErrorMessages({});

    // Get user data from localStorage
    const user = JSON.parse(localStorage.getItem("user"));
    const DefaultContactID = user?.DefaultContactID;

    // Format data for API
    // Format data for API - Robust version
    const formatData = formTemplate.map((question, index) => {
      const response = reviewerFormData[question.QuestionMasterID] || {};
      let ReviewerAnswer = "";
      let ReviewerRating = response.ReviewerRating || null;

      if (question.QuestionType_202 === 1342) {
        // Text question
        ReviewerAnswer = response.reviewerans || "";
      } else if (question.QuestionType_202 === 1343) {
        // Radio button question - handle multiple possible data structures
        const selectedOption = response.selectedOptions || response.selectedOption;
        const selectedLabel = Array.isArray(response.selectedOptionLabel)
          ? response.selectedOptionLabel[0]
          : response.selectedOptionLabel;

        // Method 1: Use selected option key
        if (selectedOption === "Option1") {
          ReviewerAnswer = question.Option1;
          ReviewerRating = question.OptionWeightage1;
        } else if (selectedOption === "Option2") {
          ReviewerAnswer = question.Option2;
          ReviewerRating = question.OptionWeightage2;
        } else if (selectedOption === "Option3") {
          ReviewerAnswer = question.Option3;
          ReviewerRating = question.OptionWeightage3;
        } else if (selectedOption === "Option4") {
          ReviewerAnswer = question.Option4;
          ReviewerRating = question.OptionWeightage4;
        }

        // Method 2: Fallback to selected label text
        if (!ReviewerAnswer && selectedLabel) {
          if (selectedLabel === question.Option1 || selectedLabel.includes(question.Option1)) {
            ReviewerAnswer = question.Option1;
            ReviewerRating = question.OptionWeightage1;
          } else if (selectedLabel === question.Option2 || selectedLabel.includes(question.Option2)) {
            ReviewerAnswer = question.Option2;
            ReviewerRating = question.OptionWeightage2;
          } else if (selectedLabel === question.Option3 || selectedLabel.includes(question.Option3)) {
            ReviewerAnswer = question.Option3;
            ReviewerRating = question.OptionWeightage3;
          } else if (selectedLabel === question.Option4 || selectedLabel.includes(question.Option4)) {
            ReviewerAnswer = question.Option4;
            ReviewerRating = question.OptionWeightage4;
          }
        }

        // Method 3: Final fallback - use whatever is in ReviewerAnswer
        if (!ReviewerAnswer && response.ReviewerAnswer) {
          ReviewerAnswer = response.ReviewerAnswer;
        }
      } else if (question.QuestionType_202 === 1347) {
        // Checkbox question
        ReviewerRating = response.ReviewerRating || 0;
        ReviewerAnswer = response.selectedOptionLabel?.join(", ") || "";
      }

      return {
        QuestionMasterID: question.QuestionMasterID,
        QuestionType_202: question.QuestionType_202,
        ReviewerAnswer: ReviewerAnswer,
        ReviewerRating: ReviewerRating,
        LineNo: index + 1,
      };
    });
    // Prepare payload
    const reviewerData = {
      ID: pr_id || null,
      AppraisalCycleID: cycle_Id,
      AppraisalTemplateMasterID: appraisalMasterID,
      ReviewerID: DefaultContactID,
      IsReviewDraft: isDraft ? "1" : "0",
      AppraisalCycleProcessType: appProcessType,
      AppraisalCycleType: appProcessID,
      EmployeeID: employeeId,
      Lines: formatData,
    };

    // Set loading states
    if (isDraft) {
      setLoadingDraft(true);
    } else {
      setLoading(true);
    }

    try {
      const response = await PostServiceCaller(
        `${API_URL}add-reviewer-feedback`,
        reviewerData,
        "post"
      );

      if (response.status === 200) {
        if (isDraft) {
          toast.success("Saved Successfully!");
          // Reset form after successful submission
          setTimeout(() => {
            setFormCount(0);
            setEmployeData(null);
            setReviewerFormData({});

          }, 2000);
        } else {
          toast.success("Feedback submitted successfully!");
          // Reset form after successful submission
          setTimeout(() => {
            setFormCount(0);
            setEmployeData(null);
            setReviewerFormData({});

          }, 2000);
        }
      } else {
        toast.error("Failed to submit reviewer feedback.");
      }
    } catch (error) {
      console.error("There was an error submitting the form data!", error);
      toast.error("Error submitting form data.");
    } finally {
      setLoading(false);
      setLoadingDraft(false);
    }
  };

  const handleCheckboxChange = (e, questionId, optionKey, optionLabel) => {
    const { checked, value } = e.target;
    setFormData(prevFormData => {
      const currentQuestionData = prevFormData[questionId] || {};

      // Create new arrays to avoid mutation issues
      const selectedOptions = Array.isArray(currentQuestionData.selectedOptions)
        ? [...currentQuestionData.selectedOptions]
        : [];

      const selectedOptionLabel = Array.isArray(currentQuestionData.selectedOptionLabel)
        ? [...currentQuestionData.selectedOptionLabel]
        : [];

      // Get current total weightage
      const currentTotalWeightage = currentQuestionData.EmployeeRating
        ? parseFloat(currentQuestionData.EmployeeRating) || 0
        : 0;

      const weightage = parseFloat(value);
      if (isNaN(weightage)) {
        console.warn("Invalid weightage:", value);
        return prevFormData;
      }

      if (!optionKey) {
        console.warn("Invalid optionKey", optionKey);
        return prevFormData;
      }

      let newTotalWeightage = currentTotalWeightage;

      if (checked) {
        // Add the option if not already present
        if (!selectedOptions.includes(optionKey)) {
          selectedOptions.push(optionKey);
          if (optionLabel !== undefined && optionLabel !== null) {
            selectedOptionLabel.push(optionLabel);
          }
          newTotalWeightage += weightage;
        }
      } else {
        // Find the index and remove from all arrays
        const optionIndex = selectedOptions.indexOf(optionKey);
        if (optionIndex > -1) {
          selectedOptions.splice(optionIndex, 1);
          // Remove from label array at the same index
          if (optionIndex < selectedOptionLabel.length) {
            selectedOptionLabel.splice(optionIndex, 1);
          }
          newTotalWeightage -= weightage;
        }
      }

      return {
        ...prevFormData,
        [questionId]: {
          ...currentQuestionData,
          selectedOptions,
          selectedOptionLabel,
          EmployeeRating: newTotalWeightage.toFixed(2) // Use toFixed for consistent formatting
        }
      };
    });

    setErrorMessages(prevErrors => {
      const newErrors = { ...prevErrors };
      if (checked) {
        delete newErrors[questionId];
      }
      return newErrors;
    });
  };

  useEffect(() => {
    if (formTemplate && formTemplate.length > 0) {
      // Update employee form data
      setFormData(prevFormData => {
        const updatedFormData = { ...prevFormData };

        formTemplate.forEach(item => {
          if (item.QuestionType_202 === 1347 && item.EmployeeAnswer) {
            const selectedLabels = item.EmployeeAnswer.split(',').map(label => label.trim());
            const selectedOptions = [];
            if (selectedLabels.includes(item.Option1)) selectedOptions.push("Option1");
            if (selectedLabels.includes(item.Option2)) selectedOptions.push("Option2");
            if (selectedLabels.includes(item.Option3)) selectedOptions.push("Option3");
            if (selectedLabels.includes(item.Option4)) selectedOptions.push("Option4");

            updatedFormData[item.QuestionMasterID] = {
              ...updatedFormData[item.QuestionMasterID],
              selectedOptions,
              selectedOptionLabel: selectedLabels,
              EmployeeRating: parseFloat(item.EmployeeRating) || 0,
              ReviewerRating: parseFloat(item.ReviewerRating) || 0
            };            
          } else if (item.QuestionType_202 === 1342) {
            updatedFormData[item.QuestionMasterID] = {
              ...updatedFormData[item.QuestionMasterID],
              answer: item.EmployeeAnswer || "",
              EmployeeRating: item.EmployeeRating || null
            };
          } else if (item.QuestionType_202 === 1343) {
            updatedFormData[item.QuestionMasterID] = {
              ...updatedFormData[item.QuestionMasterID],
              EmployeeRating: item.EmployeeRating || null,
              selectedOptionLabel: item.EmployeeAnswer ? [item.EmployeeAnswer] : []
            };
          }
        });

        return updatedFormData;
      });

      // Update reviewer form data
      setReviewerFormData(prevReviewerFormData => {
        const updatedReviewerFormData = { ...prevReviewerFormData };

        formTemplate.forEach(item => {
          if (item.QuestionType_202 === 1347 && item.ReviewerAnswer) {
            const selectedLabels = item.ReviewerAnswer.split(',').map(label => label.trim());
            const selectedOptions = [];
            if (selectedLabels.includes(item.Option1)) selectedOptions.push("Option1");
            if (selectedLabels.includes(item.Option2)) selectedOptions.push("Option2");
            if (selectedLabels.includes(item.Option3)) selectedOptions.push("Option3");
            if (selectedLabels.includes(item.Option4)) selectedOptions.push("Option4");

            updatedReviewerFormData[item.QuestionMasterID] = {
              ...updatedReviewerFormData[item.QuestionMasterID],
              selectedOptions,
              selectedOptionLabel: selectedLabels,
              ReviewerRating: parseFloat(item.ReviewerRating) || 0
            };
          } else if (item.QuestionType_202 === 1342) {
            updatedReviewerFormData[item.QuestionMasterID] = {
              ...updatedReviewerFormData[item.QuestionMasterID],
              reviewerans: item.ReviewerAnswer || "",
              ReviewerRating: item.ReviewerRating || null
            };
          } else if (item.QuestionType_202 === 1343) {
            updatedReviewerFormData[item.QuestionMasterID] = {
              ...updatedReviewerFormData[item.QuestionMasterID],
              ReviewerRating: item.ReviewerRating || null,
              selectedOptionLabel: item.ReviewerAnswer ? [item.ReviewerAnswer] : []
            };
          }
        });

        return updatedReviewerFormData;
      });
    }
  }, [formTemplate]);
  const handleReviewerSelectAllChange = (e, questionId, question) => {
    const isChecked = e.target.checked;

    setReviewerFormData((prev) => {
      const updated = { ...prev };

      // Collect all options dynamically (ignores null/empty)
      const allOptions = [
        question.Option1,
        question.Option2,
        question.Option3,
        question.Option4,
      ].filter(Boolean);

      const allWeights = [
        parseFloat(question.OptionWeightage1) || 0,
        parseFloat(question.OptionWeightage2) || 0,
        parseFloat(question.OptionWeightage3) || 0,
        parseFloat(question.OptionWeightage4) || 0,
      ].slice(0, allOptions.length); // match weights with existing options

      if (isChecked) {
        // ✅ Select all
        updated[questionId] = {
          ...updated[questionId],
          selectedOptions: allOptions.map((_, idx) => `Option${idx + 1}`),
          selectedOptionLabel: allOptions,
          ReviewerRating: allWeights.reduce((a, b) => a + b, 0).toFixed(2),
        };
      } else {
        // ❌ Unselect all
        updated[questionId] = {
          ...updated[questionId],
          selectedOptions: [],
          selectedOptionLabel: [],
          ReviewerRating: "0.00",
        };
      }

      return updated;
    });
  };


  return (
    <>

      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          {/* Filter Section */}
          <div className="row">
            <div className="col-md-3">
              <div className="col-auto">
                <label>
                  <b>Appraisal Cycle</b>
                  <span className="required">*</span>
                </label>
              </div>
              <div className="col-auto">
                <Select
                  value={appraisalCycleList?.find(ele => ele.value == cycle_Id)} // Use value for controlled behavior
                  options={appraisalCycleList}
                  onChange={handleCycleChange}
                />
              </div>
              {appraisalCycleError && (
                <div className="error-message" style={{ color: "red" }}>
                  {appraisalCycleError}
                </div>
              )}
            </div>
            {empList.length != 0 ?
              <div className="col-md-3">
                <div className="col-auto">
                  <label>
                    <b>Employee</b>
                  </label>
                </div>
                <div className="col-auto">
                  <Select
                    options={empList}
                    value={empList?.find(ele => ele?.value == employeeId)}
                    onChange={handleEmployeeChange}
                  />
                </div>
              </div> : ''}

            <div className="col-md-3">
              <div className="col-auto">
                <label>
                  <b></b>
                </label>
              </div>
              <div className="col-auto">
                <button className="custom-btn" onClick={fetchFormTemplate}>
                  Get Data
                </button>
              </div>
            </div>
          </div>

          {pageLaoding ?

            <>
              <p class="position-absolute top-50 start-50 translate-middle text-center">
                <FaSpinner class="spinner" />
              </p>
            </> : <>{/* Employee Details */}
              <div id="myTabContent" className="row mt-3">
                {employeData && (
                  <div>
                    <h3>
                      {employeData.EmployeeName}
                      <span className="fs-5"> ({employeData.Designation})</span>
                    </h3>
                    <div className="d-flex gap-5">
                      {employeData.JoiningDate && <p>
                        <strong>Joining Date:</strong>{" "}
                        {moment(employeData.JoiningDate).format("DD-MMM-YYYY")}
                      </p>}
                      <p>
                        <strong>Evaluation Date:</strong>{" "}
                        {moment().format("DD-MMM-YYYY")}
                      </p>
                      <p>
                        <strong>Reviewer:</strong> {employeData.ReviewerName}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Form Template */}
              <div className="row mt-2">
                <button
                  type="button"
                  className="scroll-btn scroll-to-bottom"
                  onClick={() => {
                    const el = document.getElementById("forJumptoUp");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  style={{
                    position: "fixed",
                    top: "70px",
                    right: "15px",
                    zIndex: "1000",
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    backgroundColor: "#27568B",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                    transition: "all 0.3s ease",
                    fontSize: "20px",
                  }}
                >
                  <i className="bi bi-arrow-down fs-6"></i>
                </button>
                {formCount === 1 && (
                  <div className="col-md-12">
                    <div className="box-body table-responsive container-fluid px-2">
                      <form onSubmit={handleSubmit}>
                        {formVisible && (
                          <Table striped bordered>
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th>#</th>
                                <th>Employee Response</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formTemplate.map((question, index) => (
                                <tr id="myTabContent" key={question.QuestionMasterID} data-question-id={question.QuestionMasterID}>
                                  <td className="text-center">{index + 1}</td>
                                  <td>
                                    <h6>
                                      <b>{question.question_title}</b>
                                    </h6>
                                    {question.QuestionType_202 === 1342 ? (
                                      <>
                                        <textarea
                                          disabled
                                          className="form-control w-100"
                                          onChange={(e) =>
                                            handleTextChange(e, question.QuestionMasterID, question)
                                          }
                                          value={formData[question.QuestionMasterID]?.answer || ""}
                                        />
                                        {errorMessages[question.QuestionMasterID] && (
                                          <small className="error">
                                            {errorMessages[question.QuestionMasterID]}
                                          </small>
                                        )}
                                        <div className="col-2 mt-2">
                                          <div className="col-2 mt-2">
                                            <input
                                              disabled
                                              type="number"
                                              min="0"
                                              max="10"
                                              step="0.01"
                                              placeholder={`Out Of ${question?.Weightage || "10.00"}`}
                                              value={
                                                formData[question.QuestionMasterID]?.EmployeeRating || null
                                              }
                                              className="form-control-sm Ques_input"
                                              onFocus={(e) => e.target.select()}
                                              onChange={(e) =>
                                                handleTextRatingChange(e, question.QuestionMasterID, question)
                                              }
                                              onWheel={(e) => e.target.blur()}
                                            />
                                          </div>{" "}
                                          {errorMessages[`${question.QuestionMasterID}_rating`] && (
                                            <small className="error d-block mt-1">
                                              {errorMessages[`${question.QuestionMasterID}_rating`]}
                                            </small>
                                          )}
                                        </div>
                                      </>
                                    ) : question.QuestionType_202 === 1343 ? (
                                      <div className="px-1">
                                        {[
                                          {
                                            key: "Option1",
                                            option: question.Option1,
                                            weightage: question.OptionWeightage1,
                                          },
                                          {
                                            key: "Option2",
                                            option: question.Option2,
                                            weightage: question.OptionWeightage2,
                                          },
                                          {
                                            key: "Option3",
                                            option: question.Option3,
                                            weightage: question.OptionWeightage3,
                                          },
                                          {
                                            key: "Option4",
                                            option: question.Option4,
                                            weightage: question.OptionWeightage4,
                                          },
                                        ].map(
                                          (item, idx) =>
                                            item.option && (
                                              <div key={idx} className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  disabled
                                                  type="radio"
                                                  name={`question-${question.QuestionMasterID}`}
                                                  value={item.weightage}
                                                  onChange={(e) =>
                                                    handleRadioChange(
                                                      e,
                                                      question.QuestionMasterID,
                                                      item.key,
                                                      item
                                                    )
                                                  }
                                                  checked={
                                                    formData[question.QuestionMasterID]?.selectedOption ===
                                                    item.key
                                                  }
                                                />
                                                <label className="form-check-label">{item.option}</label>
                                              </div>
                                            )
                                        )}

                                        {errorMessages[question.QuestionMasterID] && (
                                          <div className="error mt-2">
                                            {errorMessages[question.QuestionMasterID]}
                                          </div>
                                        )}
                                      </div>
                                    ) : question.QuestionType_202 === 1347 ? (
                                      <div className="px-1">
                                        {question.Option1 && (
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              disabled
                                              type="checkbox"
                                              value={question.OptionWeightage1}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  "Option1",
                                                  question.Option1,
                                                  question.OptionWeightage1
                                                )
                                              }
                                              checked={
                                                formData[question.QuestionMasterID]?.selectedOptions?.includes(
                                                  "Option1"
                                                ) || false
                                              }
                                            />
                                            <label className="form-check-label">{question.Option1}</label>
                                          </div>
                                        )}

                                        {question.Option2 && (
                                          <div className="form-check">
                                            <input
                                              disabled
                                              className="form-check-input"
                                              type="checkbox"
                                              value={question.OptionWeightage2}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  "Option2",
                                                  question.Option2,
                                                  question.OptionWeightage2
                                                )
                                              }
                                              checked={
                                                formData[question.QuestionMasterID]?.selectedOptions?.includes(
                                                  "Option2"
                                                ) || false
                                              }
                                            />
                                            <label className="form-check-label">{question.Option2}</label>
                                          </div>
                                        )}

                                        {question.Option3 && (
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              disabled
                                              value={question.OptionWeightage3}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  "Option3",
                                                  question.Option3,
                                                  question.OptionWeightage3
                                                )
                                              }
                                              checked={
                                                formData[question.QuestionMasterID]?.selectedOptions?.includes(
                                                  "Option3"
                                                ) || false
                                              }
                                            />
                                            <label className="form-check-label">{question.Option3}</label>
                                          </div>
                                        )}

                                        {question.Option4 && (
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              disabled
                                              value={question.OptionWeightage4}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  "Option4",
                                                  question.Option4,
                                                  question.OptionWeightage4
                                                )
                                              }
                                              checked={
                                                formData[question.QuestionMasterID]?.selectedOptions?.includes(
                                                  "Option4"
                                                ) || false
                                              }
                                            />
                                            <label className="form-check-label">{question.Option4}</label>
                                          </div>
                                        )}

                                        {/* ✅ Select All Option */}
                                        {/* <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          onChange={(e) =>
                                            handleSelectAllChange(e, question.QuestionMasterID, question)
                                          }
                                          checked={
                                            formData[question.QuestionMasterID]?.selectedOptions?.length === 4
                                          }
                                        />
                                        <label className="form-check-label">Select All</label>
                                      </div>*/}

                                        {errorMessages[question.QuestionMasterID] && (
                                          <div className="error mt-2">
                                            {errorMessages[question.QuestionMasterID]}
                                          </div>
                                        )}
                                      </div>

                                    ) : null}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}

                        {formVisible && (
                          <div className="mt-3 text-end">
                            <button type="button" className="cancel-btn me-2" onClick={() => window.location.reload()}>
                              Cancel
                            </button>



                            <button
                              type="submit"
                              disabled={loadingDraft ? true : false}

                              onClick={(e) => handleSubmit(e, true)}
                              className="custom-btn me-2"
                            >
                              {loadingDraft ? (
                                <FaSpinner class="sm-spinner" />
                              ) : (
                                "Save As Draft"
                              )}

                            </button>


                            <button
                              type="submit"
                              disabled={loading ? true : false}
                              className="custom-btn me-2"

                            >
                              {loading ? (
                                <FaSpinner class="sm-spinner" />
                              ) : (
                                "Submit"
                              )}
                            </button>
                          </div>
                        )}
                      </form>
                    </div>
                  </div>
                )}

                {formCount === 2 && (
                  <>
                    {appProcessType === "old"
                      ?
                      <>
                        <div className="col-md-6">
                          <div className="box-body table-responsive container-fluid px-2">
                            <form>
                              <Table striped bordered>
                                <thead id="thcolor" className="text-center">
                                  <tr>
                                    <th>#</th>
                                    <th>Employee Response</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {formTemplate.map((question, index) => (
                                    <tr id="myTabContent" key={question.QuestionMasterID} data-question-id={question.QuestionMasterID}>
                                      <td className="text-center">{index + 1}</td>
                                      <td>
                                        <h6>
                                          <b>{question.question_title}</b>
                                        </h6>
                                        {question.QuestionType_202 === 1342 ? (
                                          <>
                                            <textarea
                                              className="form-control w-100"
                                              disabled
                                              onChange={(e) =>
                                                handleTextChange(e, question.QuestionMasterID, question)
                                              }
                                              value={formData[question.QuestionMasterID]?.answer || ""}
                                            />
                                            <div className="col-2 mt-2">
                                              <div className="col-2 mt-2">
                                                <input
                                                  type="number"
                                                  min="0"
                                                  max="10"
                                                  step="0.01"
                                                  disabled
                                                  placeholder={`Out Of ${question?.Weightage || "10.00"}`}
                                                  value={
                                                    formData[question.QuestionMasterID]?.EmployeeRating || null
                                                  }
                                                  className="form-control-sm Ques_input"
                                                  onFocus={(e) => e.target.select()}
                                                  onChange={(e) =>
                                                    handleTextRatingChange(e, question.QuestionMasterID, question)
                                                  }
                                                  onWheel={(e) => e.target.blur()}
                                                />
                                              </div>{" "}
                                            </div>
                                          </>
                                        ) : question.QuestionType_202 === 1343 ? (
                                          <div className="px-1">
                                            {[
                                              {
                                                key: "Option1",
                                                option: question.Option1,
                                                weightage: question.OptionWeightage1,
                                              },
                                              {
                                                key: "Option2",
                                                option: question.Option2,
                                                weightage: question.OptionWeightage2,
                                              },
                                              {
                                                key: "Option3",
                                                option: question.Option3,
                                                weightage: question.OptionWeightage3,
                                              },
                                              {
                                                key: "Option4",
                                                option: question.Option4,
                                                weightage: question.OptionWeightage4,
                                              },
                                            ].map(
                                              (item, idx) =>
                                                item.option && (
                                                  <div key={idx} className="form-check">
                                                    <input
                                                      className="form-check-input"
                                                      type="radio"
                                                      disabled
                                                      name={`question-${question.QuestionMasterID}`}
                                                      value={item.weightage}
                                                      onChange={(e) =>
                                                        handleRadioChange(
                                                          e,
                                                          question.QuestionMasterID,
                                                          item.key,
                                                          item
                                                        )
                                                      }
                                                      checked={
                                                        formData[question.QuestionMasterID]?.selectedOption ===
                                                        item.key
                                                      }
                                                    />
                                                    <label className="form-check-label">{item.option}</label>
                                                  </div>
                                                )
                                            )}
                                          </div>
                                        ) : question.QuestionType_202 === 1347 ? (
                                          <div className="px-1">
                                            {question.Option1 && (
                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  disabled
                                                  value={question.OptionWeightage1}
                                                  onChange={(e) =>
                                                    handleCheckboxChange(
                                                      e,
                                                      question.QuestionMasterID,
                                                      "Option1",
                                                      question.Option1,
                                                      question.OptionWeightage1
                                                    )
                                                  }
                                                  checked={
                                                    formData[question.QuestionMasterID]?.selectedOptions?.includes(
                                                      "Option1"
                                                    ) || false
                                                  }
                                                />
                                                <label className="form-check-label">{question.Option1}</label>
                                              </div>
                                            )}

                                            {question.Option2 && (
                                              <div className="form-check">
                                                <input
                                                  disabled
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage2}
                                                  onChange={(e) =>
                                                    handleCheckboxChange(
                                                      e,
                                                      question.QuestionMasterID,
                                                      "Option2",
                                                      question.Option2,
                                                      question.OptionWeightage2
                                                    )
                                                  }
                                                  checked={
                                                    formData[question.QuestionMasterID]?.selectedOptions?.includes(
                                                      "Option2"
                                                    ) || false
                                                  }
                                                />
                                                <label className="form-check-label">{question.Option2}</label>
                                              </div>
                                            )}

                                            {question.Option3 && (
                                              <div className="form-check">
                                                <input
                                                  disabled
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage3}
                                                  onChange={(e) =>
                                                    handleCheckboxChange(
                                                      e,
                                                      question.QuestionMasterID,
                                                      "Option3",
                                                      question.Option3,
                                                      question.OptionWeightage3
                                                    )
                                                  }
                                                  checked={
                                                    formData[question.QuestionMasterID]?.selectedOptions?.includes(
                                                      "Option3"
                                                    ) || false
                                                  }
                                                />
                                                <label className="form-check-label">{question.Option3}</label>
                                              </div>
                                            )}

                                            {question.Option4 && (
                                              <div className="form-check">
                                                <input
                                                  disabled
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage4}
                                                  onChange={(e) =>
                                                    handleCheckboxChange(
                                                      e,
                                                      question.QuestionMasterID,
                                                      "Option4",
                                                      question.Option4,
                                                      question.OptionWeightage4
                                                    )
                                                  }
                                                  checked={
                                                    formData[question.QuestionMasterID]?.selectedOptions?.includes(
                                                      "Option4"
                                                    ) || false
                                                  }
                                                />
                                                <label className="form-check-label">{question.Option4}</label>
                                              </div>
                                            )}

                                            {/* ✅ Select All Option */}
                                            {/* <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          onChange={(e) =>
                                            handleSelectAllChange(e, question.QuestionMasterID, question)
                                          }
                                          checked={
                                            formData[question.QuestionMasterID]?.selectedOptions?.length === 4
                                          }
                                        />
                                        <label className="form-check-label">Select All</label>
                                      </div>*/}
                                          </div>

                                        ) : null}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </form>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="box-body table-responsive container-fluid px-2">
                            <form onSubmit={handleReviewerSubmit}>
                              <Table striped bordered>
                                <thead id="thcolor" className="text-center">
                                  <tr>
                                    <th>#</th>
                                    <th>Reviewer Response</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {formTemplate.map((question, index) => (
                                    <tr key={question.QuestionMasterID}>
                                      <td className="text-center">{index + 1}</td>
                                      <td>
                                        <h6>
                                          <b>{question.question_title}</b>
                                        </h6>
                                        {question.QuestionType_202 === 1342 ? (
                                          <>
                                            <textarea
                                              className="form-control w-100"
                                              onChange={(e) =>
                                                handleReviewerTextChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  question
                                                )
                                              }
                                              value={
                                                reviewerFormData[
                                                  question.QuestionMasterID
                                                ]?.reviewerans || null
                                              }
                                            />
                                            {errorMessages[question.QuestionMasterID] && (
                                              <small className="error">
                                                {errorMessages[question.QuestionMasterID]}
                                              </small>
                                            )}

                                            <div className="col-2 mt-2">
                                              <input
                                                type="number"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder={`Out Of ${question?.Weightage || "10.00"}`}
                                                className="form-control-sm Ques_input"
                                                onFocus={(e) => e.target.select()}
                                                value={
                                                  reviewerFormData[question.QuestionMasterID]?.ReviewerRating || null
                                                }
                                                onChange={(e) =>
                                                  handleTextRatingChange(e, question.QuestionMasterID, question)
                                                }
                                              />


                                            </div>{errorMessages[`${question.QuestionMasterID}_rating`] && (
                                              <small className="error d-block mt-1">
                                                {errorMessages[`${question.QuestionMasterID}_rating`]}
                                              </small>
                                            )}

                                          </>
                                        ) : question.QuestionType_202 === 1343 ? (
                                          <div className="px-1">
                                            {[
                                              {
                                                key: "Option1",
                                                option: question.Option1,
                                                weightage: question.OptionWeightage1,
                                              },
                                              {
                                                key: "Option2",
                                                option: question.Option2,
                                                weightage: question.OptionWeightage2,
                                              },
                                              {
                                                key: "Option3",
                                                option: question.Option3,
                                                weightage: question.OptionWeightage3,
                                              },
                                              {
                                                key: "Option4",
                                                option: question.Option4,
                                                weightage: question.OptionWeightage4,
                                              },
                                            ].map((item, idx) =>
                                              item.option && (
                                                <div key={idx} className="form-check">
                                                  <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name={`reviewer-question-${question.QuestionMasterID}`}
                                                    value={item.weightage}
                                                    onChange={(e) => handleReviewerRadioChange(e, question.QuestionMasterID, item.key, item)}
                                                    checked={reviewerFormData[question.QuestionMasterID]?.selectedOptions === item.key}
                                                  />
                                                  <label className="form-check-label">
                                                    {item.option}
                                                  </label>
                                                </div>
                                              )
                                            )} {errorMessages[question.QuestionMasterID] && (
                                              <div className="error mt-2">
                                                {errorMessages[question.QuestionMasterID]}
                                              </div>
                                            )}
                                          </div>


                                        ) : question.QuestionType_202 === 1347 ? (
                                          <div className="px-1">
                                            {question.Option1 && (
                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage1}
                                                  onChange={(e) =>
                                                    handleReviewerCheckboxChange(e, question.QuestionMasterID, "Option1", question.Option1)
                                                  }
                                                  checked={
                                                    reviewerFormData[question.QuestionMasterID]?.selectedOptions?.includes("Option1") || false
                                                  }
                                                />
                                                <label className="form-check-label">
                                                  {question.Option1}
                                                </label>
                                              </div>
                                            )}
                                            {question.Option2 && (
                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage2}
                                                  onChange={(e) =>
                                                    handleReviewerCheckboxChange(e, question.QuestionMasterID, "Option2", question.Option2)
                                                  }
                                                  checked={
                                                    reviewerFormData[question.QuestionMasterID]?.selectedOptions?.includes("Option2") || false
                                                  }
                                                />
                                                <label className="form-check-label">
                                                  {question.Option2}
                                                </label>
                                              </div>
                                            )}
                                            {question.Option3 && (
                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage3}
                                                  onChange={(e) =>
                                                    handleReviewerCheckboxChange(e, question.QuestionMasterID, "Option3", question.Option3)
                                                  }
                                                  checked={
                                                    reviewerFormData[question.QuestionMasterID]?.selectedOptions?.includes("Option3") || false
                                                  }
                                                />
                                                <label className="form-check-label">
                                                  {question.Option3}
                                                </label>
                                              </div>
                                            )}
                                            {question.Option4 && (
                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage4}
                                                  onChange={(e) =>
                                                    handleReviewerCheckboxChange(e, question.QuestionMasterID, "Option4", question.Option4)
                                                  }
                                                  checked={
                                                    reviewerFormData[question.QuestionMasterID]?.selectedOptions?.includes("Option4") || false
                                                  }
                                                />
                                                <label className="form-check-label">
                                                  {question.Option4}
                                                </label>
                                              </div>
                                            )}
                                            {/* ✅ Select All Option */}
                                            {/* <div className="form-check">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(e) =>
                                                  handleReviewerSelectAllChange(e, question.QuestionMasterID, question)
                                                }
                                                checked={
                                                  reviewerFormData[question.QuestionMasterID]?.selectedOptions?.length ===
                                                  [question.Option1, question.Option2, question.Option3, question.Option4].filter(Boolean).length
                                                }
                                              />
                                              <label className="form-check-label">Select All</label>
                                            </div>*/}

                                            {errorMessages[question.QuestionMasterID] && (
                                              <div className="error mt-2">
                                                {errorMessages[question.QuestionMasterID]}
                                              </div>
                                            )}
                                          </div>
                                        ) : null}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                              <div id="forJumptoUp" className="mt-3 text-end">
                                <button type="button" className="cancel-btn me-2" onClick={() => window.location.reload()}>
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  disabled={loadingDraft ? true : false}

                                  onClick={(e) => handleReviewerSubmit(e, true)}
                                  className="custom-btn me-2"
                                >
                                  {loadingDraft ? (
                                    <FaSpinner class="sm-spinner" />
                                  ) : (
                                    "Save As Draft"
                                  )}

                                </button>


                                <button
                                  type="submit"
                                  disabled={loading ? true : false}
                                  className="custom-btn me-2"

                                >
                                  {loading ? (
                                    <FaSpinner class="sm-spinner" />
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </>
                      : <>
                        {templateAPIStatus!==201 && templateAPIStatus!== 404 ? <div className="col-md-12">
                          <div className="box-body table-responsive container-fluid px-2">
                            <form onSubmit={handleReviewerSubmit}>
                              <Table striped bordered>
                                <thead id="thcolor" className="text-center">
                                  <tr>
                                    <th>#</th>
                                    <th>Reviewer Response</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {formTemplate.map((question, index) => (
                                    <tr key={question.QuestionMasterID}>
                                      <td className="text-center">{index + 1}</td>
                                      <td>
                                        <h6>
                                          <b>{question.question_title}</b>
                                        </h6>
                                        {question.QuestionType_202 === 1342 ? (
                                          <>
                                            <textarea
                                              className="form-control w-100"
                                              onChange={(e) =>
                                                handleReviewerTextChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  question
                                                )
                                              }
                                              value={
                                                reviewerFormData[
                                                  question.QuestionMasterID
                                                ]?.reviewerans || ""
                                              }
                                            />
                                            {errorMessages[question.QuestionMasterID] && (
                                              <small className="error">
                                                {errorMessages[question.QuestionMasterID]}
                                              </small>
                                            )}
                                            <div className="col-2 mt-2">
                                              <input
                                                type="number"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder={`Out Of ${question?.Weightage || "10.00"}`}
                                                className="form-control-sm Ques_input"
                                                onFocus={(e) => e.target.select()}
                                                value={
                                                  reviewerFormData[question.QuestionMasterID]?.ReviewerRating || null
                                                }
                                                onChange={(e) =>
                                                  handleTextRatingChange(e, question.QuestionMasterID, question)
                                                }
                                              />


                                            </div>{errorMessages[`${question.QuestionMasterID}_rating`] && (
                                              <small className="error d-block mt-1">
                                                {errorMessages[`${question.QuestionMasterID}_rating`]}
                                              </small>
                                            )}

                                          </>
                                        ) : question.QuestionType_202 === 1343 ? (
                                          <div className="px-1">
                                            {[
                                              {
                                                key: "Option1",
                                                option: question.Option1,
                                                weightage: question.OptionWeightage1,
                                              },
                                              {
                                                key: "Option2",
                                                option: question.Option2,
                                                weightage: question.OptionWeightage2,
                                              },
                                              {
                                                key: "Option3",
                                                option: question.Option3,
                                                weightage: question.OptionWeightage3,
                                              },
                                              {
                                                key: "Option4",
                                                option: question.Option4,
                                                weightage: question.OptionWeightage4,
                                              },
                                            ].map((item, idx) =>
                                              item.option && (
                                                <div key={idx} className="form-check">
                                                  <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name={`reviewer-question-${question.QuestionMasterID}`}
                                                    value={item.weightage}
                                                    onChange={(e) => handleReviewerRadioChange(e, question.QuestionMasterID, item.key, item)}
                                                    checked={reviewerFormData[question.QuestionMasterID]?.selectedOptions === item.key}
                                                  />
                                                  <label className="form-check-label">
                                                    {item.option}
                                                  </label>
                                                </div>
                                              )
                                            )} {errorMessages[question.QuestionMasterID] && (
                                              <div className="error mt-2">
                                                {errorMessages[question.QuestionMasterID]}
                                              </div>
                                            )}
                                          </div>


                                        ) : question.QuestionType_202 === 1347 ? (
                                          <div className="px-1">
                                            {question.Option1 && (
                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage1}
                                                  onChange={(e) =>
                                                    handleReviewerCheckboxChange(e, question.QuestionMasterID, "Option1", question.Option1)
                                                  }
                                                  checked={
                                                    reviewerFormData[question.QuestionMasterID]?.selectedOptions?.includes("Option1") || false
                                                  }
                                                />
                                                <label className="form-check-label">
                                                  {question.Option1}
                                                </label>
                                              </div>
                                            )}
                                            {question.Option2 && (
                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage2}
                                                  onChange={(e) =>
                                                    handleReviewerCheckboxChange(e, question.QuestionMasterID, "Option2", question.Option2)
                                                  }
                                                  checked={
                                                    reviewerFormData[question.QuestionMasterID]?.selectedOptions?.includes("Option2") || false
                                                  }
                                                />
                                                <label className="form-check-label">
                                                  {question.Option2}
                                                </label>
                                              </div>
                                            )}
                                            {question.Option3 && (
                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage3}
                                                  onChange={(e) =>
                                                    handleReviewerCheckboxChange(e, question.QuestionMasterID, "Option3", question.Option3)
                                                  }
                                                  checked={
                                                    reviewerFormData[question.QuestionMasterID]?.selectedOptions?.includes("Option3") || false
                                                  }
                                                />
                                                <label className="form-check-label">
                                                  {question.Option3}
                                                </label>
                                              </div>
                                            )}
                                            {question.Option4 && (
                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={question.OptionWeightage4}
                                                  onChange={(e) =>
                                                    handleReviewerCheckboxChange(e, question.QuestionMasterID, "Option4", question.Option4)
                                                  }
                                                  checked={
                                                    reviewerFormData[question.QuestionMasterID]?.selectedOptions?.includes("Option4") || false
                                                  }
                                                />
                                                <label className="form-check-label">
                                                  {question.Option4}
                                                </label>
                                              </div>
                                            )}
                                            {/* ✅ Select All Option */}
                                            {/* <div className="form-check">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(e) =>
                                                  handleReviewerSelectAllChange(e, question.QuestionMasterID, question)
                                                }
                                                checked={
                                                  reviewerFormData[question.QuestionMasterID]?.selectedOptions?.length ===
                                                  [question.Option1, question.Option2, question.Option3, question.Option4].filter(Boolean).length
                                                }
                                              />
                                              <label className="form-check-label">Select All</label>
                                            </div> */}

                                            {errorMessages[question.QuestionMasterID] && (
                                              <div className="error mt-2">
                                                {errorMessages[question.QuestionMasterID]}
                                              </div>
                                            )}
                                          </div>
                                        ) : null}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                              <div id="forJumptoUp" className="mt-3 text-end">
                                <button type="button" className="cancel-btn me-2" onClick={() => window.location.reload()}>
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  disabled={loadingDraft ? true : false}

                                  onClick={(e) => handleReviewerSubmit(e, true)}
                                  className="custom-btn me-2"
                                >
                                  {loadingDraft ? (
                                    <FaSpinner class="sm-spinner" />
                                  ) : (
                                    "Save As Draft"
                                  )}

                                </button>


                                <button
                                  type="submit"
                                  disabled={loading ? true : false}
                                  className="custom-btn me-2"

                                >
                                  {loading ? (
                                    <FaSpinner class="sm-spinner" />
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>:null}
                      </>

                    }
                  </>
                )}
                <button
                  type="button"
                  className="back-to-top-btn"
                  onClick={() => {
                    const el = document.getElementById("myTabContent");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  style={{
                    position: "fixed",
                    bottom: "40px",
                    right: "15px",
                    zIndex: 1000,
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    backgroundColor: "#27568B",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                    transition: "all 0.3s ease",
                    fontSize: "20px",
                  }}
                >
                  <i className="bi bi-arrow-up fs-6"></i>
                </button>
              </div>
           {/* Status Section */}



              
              </>}
        </div>
      </div>

    {templateAPIStatus === 201 ? (
  <div
    style={{
      maxWidth: '400px',
      margin: '2rem auto',
      padding: '1.5rem',
      border: '1px solid #ddd',
      borderRadius: '0.5rem',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      textAlign: 'center',
      backgroundColor: '#fff',
    }}
  >
    <div
      style={{
        width: '64px',
        height: '64px',
        backgroundColor: '#FFE8D6',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 1rem',
      }}
    >
      <AlertCircle style={{ width: '32px', height: '32px', color: '#FF8C42' }} />
    </div>

    <h3
      style={{
        fontSize: '1.25rem',
        fontWeight: '600',
        color: '#dc5a5aff',
        marginBottom: '0.5rem',
      }}
    >
      {templateMessage}
    </h3>

    {/* <p style={{ color: '#475569', marginTop: '1rem' }}>
      A template needs to be assigned to this appraisal cycle before data can be retrieved.
    </p> */}
  </div>
) : null}


    </>
  );
};

export default TeamPerformanceEvaluation;